/* eslint-disable remix-react-routes/use-link-for-routes */
export default function Personal() {
	return (
		<div className="container mx-auto py-2">
			<h1 className="mb-3 text-5xl">Personal</h1>
			{/* todo: add headshot */}
			{/* <h2>Work</h2> */}
			<p className="mb-4 text-lg">
				<span className="text-bold">Location: </span>
				{location}
			</p>

			<h2 className="mt-2 text-3xl">Languages</h2>
			<ul className="list-inside list-disc">
				{languages.map(language => {
					return (
						<li key={language.name}>
							{language.name} ({language.level})
						</li>
					)
				})}
			</ul>
			<h2 className="mt-4 text-3xl">Interests</h2>
			<div>
				{personalInterests.map(interest => {
					return (
						<div key={interest.categoryName} className="mb-3">
							{interest.categoryName}
							<ul className="list-inside list-disc">
								{interest.list.map(item => {
									return <li key={item}>{item}</li>
								})}
							</ul>
						</div>
					)
				})}
			</div>
			<h2 className="mt-4 text-3xl">Links</h2>
			<ul className="list-inside list-disc">
				{links.map(link => (
					<li key={link.name}>
						<a href={link.url} className="hover:text-blue-500">
							{link.name}
						</a>
					</li>
				))}
			</ul>
			<h2 className="mt-4 text-3xl">Contact</h2>
			<ul className="list-inside list-disc">
				<li>
					<a
						className="hover:text-blue-500"
						href={`mailto:${contactInfo.email}`}
					>
						{contactInfo.email}
					</a>
				</li>
			</ul>
		</div>
	)
}

const location = 'Toronto, Canada'

const personalInterests = [
	{ categoryName: 'Sports', list: ['tennis', 'squash'] },
	{ categoryName: 'Dance', list: ['lindy hop (swing)', 'blues', 'fusion'] },
]

const languages = [
	{ name: 'Mandarin', level: 'intermediate' },
	{ name: 'Italian', level: 'intermediate' },
	{ name: 'French', level: 'beginner/intermediate' },
]

const links = [
	{ name: 'GitHub', url: 'https://github.com/sys13' },
	{ name: 'LinkedIn', url: 'https://www.linkedin.com/in/danielarrizza' },
]

const contactInfo = { email: 'daniel.arrizza@gmail.com' }

// const personalMe = `
// quick info:
// - Software Engineer and Client Facing Consultant

// Awards:
// -

// References

// `
